const AddTagIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5222 16.8652C27.107 17.45 27.4355 18.2432 27.4355 19.0702C27.4355 19.8972 27.107 20.6904 26.5222 21.2753L19.286 28.5115C18.7012 29.0962 17.908 29.4247 17.081 29.4247C16.2539 29.4247 15.4608 29.0962 14.8759 28.5115L4.89893 18.5345C4.41354 18.0492 4.14077 17.3911 4.14062 16.7047V10.012C4.14063 8.98239 4.54963 7.99496 5.27767 7.26692C6.0057 6.53889 6.99313 6.12988 8.02273 6.12988H14.7155C15.4018 6.13003 16.06 6.4028 16.5452 6.88819L18.7021 9.04217"
        stroke="white"
        strokeWidth="1.94105"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6152 8.06836H29.3794"
        stroke="white"
        strokeWidth="1.94105"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4961 4.18457V11.9488"
        stroke="white"
        strokeWidth="1.94105"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AddTagIcon;
